import { styled, TextField } from '@mui/material';

const StyledTextField = styled(TextField)(({ theme }) => ({
    '& .MuiInput-underline:before': {
        borderBottom: `1px solid ${theme.palette.divider}`,
    },
    '& .MuiInput-underline:hover:not(.Mui-disabled, .Mui-error):before': {
        borderBottom: `2px solid ${theme.palette.divider}`,
    },
}));

function MyTextField(props) {
    return <StyledTextField variant='standard' {...props} />;
}

export { MyTextField };
